import { observer } from 'mobx-react';
import { createElement } from 'react';

import SiteHeader from '../../b2c/layout/SiteHeader/SiteHeader';
import { AppState } from '../AppState';
import { TopBarTranslation } from '../localization/SiteTranslation';
import GeneralHeader from './GeneralHeader/GeneralHeader';
import { WithShowroomTimer } from './WithShowroomTimer';

export interface TopbarProps {
  className?: string;
  logoLink?: string;
  modelName?: string;
  translation: TopBarTranslation;
  appState: AppState;
  isLogoSmall?: boolean;
}

const Topbar = observer((props: TopbarProps) => {
  const { appState, logoLink } = props;
  const isShowroom = appState.store?.isShowroom();

  if (!logoLink) {
    props = {
      ...props,
      logoLink: isShowroom
        ? appState.storeResponse.storeContext.showroomConfig.homePageUrl
        : appState.navigationState.homeUrl,
    };
  }

  if (!appState.siteHeaderState) {
    return createElement(isShowroom ? WithShowroomTimer(GeneralHeader) : GeneralHeader, props);
  }

  const siteHeader = <SiteHeader state={appState.siteHeaderState} />;

  if (isShowroom) {
    const ShowroomHeader = WithShowroomTimer((_: { appState: AppState }) => siteHeader);
    return <ShowroomHeader appState={appState} />;
  }

  return siteHeader;
});

export default Topbar;
